<template>
  <div class="lotto-promo p-n rounded-3">
    <div class="sport-icon" v-html="sport.svg"></div>

    <div class="lotto-promo-text text-ellipsies">New 49 Lotto</div>

    <vue-button 
      sm
      cls="main" 
      class="lotto-promo-btn"
      @click="goToLotto" 
    >PLAY</vue-button>

  </div>
</template>

<script>
import VueButton from "@/components/UI/VueButton";

export default {
  name: "LottoPromoSidebar",
  components: {
    VueButton
  },
  computed: {
    sport() {
      return this.API.SPORTS.find(sport => sport.code === 'L')
    }
  },
  methods: {
    goToLotto() {
      this.$router.push({name: 'sport', params:{sportName: 'Lotto'}})
    }
  }

}
</script>

<style scoped lang="scss">
  .lotto-promo {
    background-color: var(--geoff-bg-section);
    overflow: hidden;
    display: flex;
    gap: 1rem;
    justify-content: space-between;
    align-items: center;
    color: var(--geoff-accent);

    .sport-icon {
      width: 2.5rem;
      height: 2.5rem;
      display: flex;
    }

    .lotto-promo-text {
      text-transform: uppercase;
      font-weight: 700;
      font-size: 1.25rem;
    }

    .lotto-promo-btn {
      width: auto;
      font-weight: 700;
      flex-grow: 0.6;
    }
   
  }
</style>